define(
    'Tavanoteam.TavanoTeam_Home_Extension.Home'
    , [
        'Utils',
        'Tavanoteam.TavanoTeam_Home_Extension.HomeElements.View',
        'Tavanoteam.TavanoTeam_Home_Extension.HomeSlider.View'
    ]
    , function (
        Utils,
        HomeElementsView,
        HomeSliderView
    ) {

        'use strict';

        return {
            
            mountToApp: function mountToApp(container) {
                /** @type {LayoutComponent} */

                var environment = container.getComponent("Environment");
                var layout = container.getComponent("Layout");

                /* Get config data */

                var homeData = environment.getConfig("tavanoTeamHomeExtension");

                var config_sections = homeData.sections;
                var cms_elements = homeData.cmsElements;
                var titles_elements = homeData.titleElements;
                var html_elements = homeData.htmlElements;
                var infoBoxes_elements = homeData.infoBoxElements;
                var banners_elements = homeData.bannerElements;

                titles_elements.forEach(function (a) { a.titleElement = true; });
                html_elements.forEach(function (a) { a.htmlElement = true; });
                infoBoxes_elements.forEach(function (a) { a.infoBoxElement = true; });
                banners_elements.forEach(function (a) { a.bannerElement = true; });

                var slider_element = homeData.slider;

                /* Reorder sections */
                if (config_sections.length > 0) {
                    config_sections.sort(function (a, b) { return a.order - b.order; });
                }

                /* Concat elements */
                var allElements = [];
                allElements = allElements.concat(cms_elements, titles_elements, html_elements, infoBoxes_elements, banners_elements);

                var configureHTMLContent = function (html) {

                    if (!!html) {
                        /* Translate */
                        var translate_text = html.split("translate[[");
                        if (translate_text.length > 1) {
                            translate_text.shift();
                            for (var i = 0; i < translate_text.length; i++) {
                                translate_text[i] = translate_text[i].split("]]")[0];
                                var value_origin = "translate[[" + translate_text[i] + "]]";
                                var value_translated = Utils.translate(translate_text[i]);
                                html = html.replace(value_origin, value_translated);
                            }
                        }

                        /* Remove whitespaces in the DOM. */
                        /* It's not a common space (Red Dots - ""). Do NOT remove this line! */
                        html = html.replace(/\5/g, "");
                    }

                    return html;
                }

                var removeHTMLLinks = function (html) {

                    var links_in_html = html.split("<a");

                    if (links_in_html.length > 1) {
                        links_in_html.shift();

                        for (var i = 0; i < links_in_html.length; i++) {
                            links_in_html[i] = links_in_html[i].split("</a>")[0];
                            var value_origin = "<a" + links_in_html[i] + "</a>";
                            html = html.replace(value_origin, "");
                        }
                    }

                    return html;
                }

                /* Info Box settings */
                var infoBoxSetting = function (data) {

                    var contentStyles = "style=\"";
                    contentStyles += !!data.background ? "background: " + data.background.replace("\"", "'") + ";" : "";
                    contentStyles += "\"";

                    var contentClasses = !!data.textColor ? "text-color-" + data.textColor.toLowerCase() : "";
                    contentClasses += !!data.textWeight ? " text-weight-" + data.textWeight.toLowerCase() : "";
                    contentClasses += " tt-ext-home-infobox-align-desktop-" + data.positionDesktop.toLowerCase();
                    contentClasses += " tt-ext-home-infobox-align-mobile-" + data.positionMobile.toLowerCase();
                    contentClasses += !!data.additionalClass ? " " + data.additionalClass : "";

                    var html = configureHTMLContent(data.content);

                    if (data.link) {
                        html = removeHTMLLinks(html);

                        if (data.touchpoint === "none") {
                            data.touchpoint = false;
                        }
                    }

                    return {
                        infoBox: true,
                        dataHomeId: data.id,
                        contentClasses: contentClasses,
                        contentStyles: contentStyles,
                        content: html,
                        link: data.link,
                        touchpoint: data.touchpoint
                    };
                };

                /* Banner settings */
                var bannerSetting = function (data) {

                    if (!data.imgSrcDesktop && !data.imgSrcMobile) {
                        return false;
                    }

                    if (!data.imgSrcDesktop) {
                        data.imgSrcDesktop = data.imgSrcMobile;
                        data.imgSrcMobile = '';
                    }

                    var contentInfoClasses = "";
                    contentInfoClasses = 'tt-ext-home-banner-content-position-desktop-' + data.positionDesktop.toLowerCase().replace('middle-', 'center-');
                    contentInfoClasses += ' tt-ext-home-banner-content-position-mobile-' + data.positionMobile.toLowerCase().replace('middle-', 'center-');
                    contentInfoClasses += ' text-color-' + data.textColor.toLowerCase();
                    contentInfoClasses += ' text-shadow-' + data.textShadow.toLowerCase();
                    contentInfoClasses += ' ' + data.additionalClass;

                    var html = configureHTMLContent(data.content);

                    if (data.link) {
                        html = removeHTMLLinks(html);

                        if (data.touchpoint === "none") {
                            data.touchpoint = false;
                        }
                    }

                    return {
                        banner: true,
                        dataHomeId: data.id,
                        backgroundImage: (data.backgroundImg || data.parallax),
                        parallax: data.parallax,
                        desktopImage: data.imgSrcDesktop,
                        mobileImage: data.imgSrcMobile,
                        imageAlt: data.imgAlt,
                        contentInfoClasses: contentInfoClasses,
                        content: html,
                        link: data.link,
                        touchpoint: data.touchpoint
                    };
                };

                /*Sections settings */
                var sectionPadding = function (value) {
                    if (value === "No Padding") {
                        return "0";
                    } else {
                        return value.replace("Padding ","");
                    }
                };

                var sectionMargin = function (value) {
                    if (value === "No Margin") {
                        return "0";
                    } else {
                        return value.replace("Margin ","");
                    }
                };

                /* Create Sections */
                var home_sections = [];

                for (var i = 0; i < config_sections.length; i++) {

                    var title = { text: "", tag: "", class: "", dataHomeId: "" };
                    var slider = { enabled: false, dataHomeId: "" };
                    var section_elements = [];
                    var elements_id = config_sections[i].elementsId.split(",");

                    /* Create elements of sections */
                    for (var j = 0; j < elements_id.length; j++) {

                        /* Slider element */
                        if (!slider.enabled && elements_id[j] === slider_element.id) {

                            layout.addChildView("TavanoTeamHomeExtensionSlider", function () {

                                slider_element.layout = layout;

                                return new HomeSliderView(slider_element);
                            });

                            slider.dataHomeId = slider_element.id;
                            slider.enabled = true;
                        }

                        for (var k = 0; k < allElements.length; k++) {

                            if (elements_id[j] === allElements[k].id) {

                                /* CMS Area element */
                                if (!!allElements[k].cmsArea) {

                                    section_elements.push({
                                        dataHomeId: allElements[k].id,
                                        cmsArea: allElements[k].cmsArea
                                    });
                                }

                                /* InfoBox element */
                                if (!!allElements[k].infoBoxElement) {

                                    var data = infoBoxSetting(allElements[k]);

                                    section_elements.push(data);
                                }

                                /* Banner element */
                                if (!!allElements[k].bannerElement) {

                                    var data = bannerSetting(allElements[k]);

                                    if (!!data) {
                                        section_elements.push(data);
                                    }
                                }

                                /* Title element */
                                if (allElements[k].titleElement) {

                                    title.dataHomeId = allElements[k].id;
                                    title.tag = allElements[k].tag.toLowerCase();
                                    title.text = configureHTMLContent(allElements[k].mainContent);
                                    title.class = allElements[k].customClass;
                                }

                                /* HTML element */
                                if (allElements[k].htmlElement) {

                                    section_elements.push({
                                        dataHomeId: allElements[k].id,
                                        html: configureHTMLContent(allElements[k].mainContent),
                                        class: allElements[k].customClass
                                    });
                                }
                            }
                        }
                    }

                    /* Section classes */
                    var section_class = config_sections[i].customClass;
                    section_class += " tt-ext-home-top-space-" + sectionMargin(config_sections[i].topSpace);
                    section_class += " tt-ext-home-bottom-space-" + sectionMargin(config_sections[i].bottomSpace);
                    section_class += " tt-ext-home-elements-space-" + sectionPadding(config_sections[i].elementsSpace);

                    /* Container class */
                    switch (config_sections[i].container) {
                        case "No": config_sections[i].container = ""; break;
                        case "Yes": config_sections[i].container = "tt-ext-home-container"; break;
                        case "Fluid": config_sections[i].container = "tt-ext-home-container-fluid"; break;
                        case "Only Desktop": config_sections[i].container = "tt-ext-home-container-desktop"; break;
                    }

                    /* Add section to data */
                    home_sections.push({
                        container: config_sections[i].container,
                        dataHomeElementsId: config_sections[i].elementsId,
                        title: title,
                        slider: slider,
                        elements: section_elements.length > 0 ? section_elements : "",
                        class: section_class,
                        sectionBackground: config_sections[i].background
                    });
                }

                /* Send data to home */
                if (layout) {

                    layout.addToViewContextDefinition("Home.View", "tavanoTeamHomeExtension", "boolean", function () {

                        return true;
                    });

                    layout.addChildView("TavanoTeamHomeExtension", function () {

                        return new HomeElementsView({
                            sections: home_sections
                        });
                    });

                }
            }
        };
    }
);
